import { render, staticRenderFns } from "./gossipimage.vue?vue&type=template&id=21eaf6de&scoped=true"
import script from "./gossipimage.vue?vue&type=script&lang=js"
export * from "./gossipimage.vue?vue&type=script&lang=js"
import style0 from "./gossipimage.vue?vue&type=style&index=0&id=21eaf6de&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21eaf6de",
  null
  
)

export default component.exports